<template>
  <div class="login">
    <div class="el-loagin-top flex align-center">
      <img src="@/assets/img/logo.png" class="logo-img" />
      <span class="f-mr20 orange">●</span><h2 class="title text-weight blue">在线学习考试系统</h2>
    </div>
    <div class="login-middle">
      <el-row type="flex" align="middle" class="login-con" :style="{width: width>768?'1200px':'100%'}">
        <el-col :span="12">
          <el-image :src="loginImg" class="login-img"></el-image>
        </el-col>
        <el-col :xs="24" :sm="12">
          <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
            <h2 class="title">用户登录</h2>
            <el-form-item prop="username">
              <el-input v-model="loginForm.username" prefix-icon="el-icon-user" type="text" auto-complete="off"
                placeholder="请输入手机号/身份证号/准考证号">
                <!-- <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" /> -->
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="loginForm.password" prefix-icon="el-icon-lock" type="password" auto-complete="off"
                placeholder="密码" @keyup.enter.native="handleLogin">
                <!-- <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" /> -->
              </el-input>
            </el-form-item>
            <el-form-item prop="code" v-if="captchaOnOff">
              <el-input v-model="loginForm.code" auto-complete="off" placeholder="验证码" style="width: 67%"
                @keyup.enter.native="handleLogin">
                <!-- <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" /> -->
              </el-input>
              <div class="login-code">
                <img :src="codeUrl" @click="getCode" class="login-code-img" />
              </div>
            </el-form-item>
            <el-form-item style="width:100%;">
              <el-button :loading="loading" size="medium" type="primary" style="width:100%;"
                @click.native.prevent="handleLogin">
                <span v-if="!loading">登 录</span>
                <span v-else>登 录 中...</span>
              </el-button>
            </el-form-item>
            <div class="flex justify-end">
              <router-link class="link-type text-right" :to="'/changePassword'">忘记密码</router-link>
              <!-- <router-link class="link-type" :to="'/register'">立即注册</router-link> -->
            </div>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <!--  底部  -->
    <div class="el-login-footer flex-center">
      <p class="f-m10">版权所有 © 赢拓教育科技集团有限公司</p>
      <p class="f-m10">网站备案号：京ICP备20021063号</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'; // 导入axios库
import Cookies from "js-cookie";
import { encrypt, decrypt } from '@/utils/jsencrypt'

export default {
  name: "Login",
  data() {
    return {
      codeUrl: "",
      loginImg: require('@/assets/img/15791664.png'),
      loginForm: {
        username: "",
        password: "",
        rememberMe: false,
        code: "Nzc0MzgyNDc4NTI2",
        uuid: ""
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入您的账号" }
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" }
        ],
        code: [{ required: false, trigger: "change", message: "请输入验证码" }]
      },
      loading: false,
      // 验证码开关
      captchaOnOff: true,
      // 注册开关
      register: false,
      redirect: undefined,
      width: 0
    };
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created() {
    this.getCode();
    this.getCookie();
    this.width = document.body.scrollWidth
  },
  methods: {
    getCode() {
      const url = "https://se.51shizhan.cn/api/captchaImage";
      axios.get(url).then(res => {
        this.captchaOnOff = res.captchaOnOff === undefined ? true : res.captchaOnOff;
        if (this.captchaOnOff) {
          this.codeUrl = res.data.img;
          this.loginForm.uuid = res.data.uuid;
        }
      })
    },
    getCookie() {
      const username = Cookies.get("username");
      const password = Cookies.get("password");
      const rememberMe = Cookies.get('rememberMe')
      this.loginForm = {
        username: username === undefined ? this.loginForm.username : username,
        password: password === undefined ? this.loginForm.password : decrypt(password),
        rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
      };
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.loginForm.rememberMe) {
            Cookies.set("username", this.loginForm.username, { expires: 30 });
            Cookies.set("password", encrypt(this.loginForm.password), { expires: 30 });
            Cookies.set('rememberMe', this.loginForm.rememberMe, { expires: 30 });
          } else {
            Cookies.remove("username");
            Cookies.remove("password");
            Cookies.remove('rememberMe');
          }
          this.$store.dispatch("Login", this.loginForm).then((res) => {
            console.log(res.data)
            if(res.data.code == 200){
              this.$router.push({ path: this.redirect || "/" }).catch(()=>{});
            } else {
              this.loading = false;
              this.$message.error(res.data.msg);
              if (this.captchaOnOff) {
                this.getCode();
              }
            }
            
          }).catch(() => {
            this.loading = false;
            if (this.captchaOnOff) {
              this.getCode();
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  flex-direction: column;
  height: 100%;

  .el-loagin-top {
    width: 1200px;
    margin: 50px auto;

    .logo-img {
      width: 200px;
    }
  }

  .login-middle {
    width: 100%;
    background: linear-gradient(to left top, #5fa4fd, #0d4fa5);

    .login-con {
      margin: 40px auto;

      .login-img {
        width: 74%;
        margin: 50px auto;
        display: block;
      }

      .login-form {
        max-width: 400px;
        margin-left: 10%;
        text-align: center;
        border-radius: 6px;
        padding: 30px 25px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);

        .title {
          margin-bottom: 30px;
        }

        .el-input {
          height: 38px;

          input {
            height: 38px;
          }
        }

        .input-icon {
          height: 39px;
          width: 14px;
          margin-left: 2px;
        }

        .login-code {
          width: 33%;
          height: 38px;
          float: right;

          .login-code-img {
            width: 95%;
            margin-left: 5%;
            border-radius: 5px;
            height: 38px;
          }
        }
      }

    }
  }
}


.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.link-type {
  margin-left: 15px;
}
</style>
